var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandGoogleYouTubeStyleWhite = function SvgBrandGoogleYouTubeStyleWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandGoogleYouTubeStyleWhite__clip0_3953_130853)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22.691 5.287c.373.373.641.836.779 1.345.793 3.19.61 8.23.015 11.544a3.02 3.02 0 0 1-2.124 2.124c-1.862.508-9.358.508-9.358.508s-7.496 0-9.358-.508A3.02 3.02 0 0 1 .52 18.176c-.798-3.177-.579-8.22-.016-11.528A3.02 3.02 0 0 1 2.63 4.523C4.492 4.015 11.988 4 11.988 4s7.496 0 9.358.508c.509.138.973.406 1.345.779m-6.87 7.117L9.6 16.006V8.802z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandGoogleYouTubeStyleWhite__clip0_3953_130853"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandGoogleYouTubeStyleWhite);
export { ForwardRef as ReactComponent };